import { useTranslation } from 'react-i18next';
import { GoldThread } from '@/components/brand/GoldThread';

export default function AboutPage() {
  const { t } = useTranslation();

  return (
    <>
      {/* Title block — large statement on left, lead paragraph on right */}
      <section className="bg-bone">
        <div className="container pt-20 pb-16 md:pt-32 md:pb-24">
          <div className="grid grid-cols-12 gap-y-10 gap-x-6">
            <div className="col-span-12 md:col-span-7 animate-fade-up">
              <div className="flex items-center gap-4 mb-6">
                <GoldThread />
                <span className="eyebrow">{t('nav.about')}</span>
              </div>
              <h1 className="font-display text-d-2 text-ink"
                  style={{ fontVariationSettings: "'opsz' 144, 'wght' 500" }}>
                {t('about.title')}
              </h1>
            </div>
            <div className="col-span-12 md:col-span-5 md:pt-8">
              <p className="font-body text-lg text-charcoal leading-relaxed">
                {t('about.lead')}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Philosophy + How we work — two numbered sections */}
      <section className="container pb-24 md:pb-32">
        <div className="grid grid-cols-12 gap-y-16 gap-x-6">
          <AboutSection num="01" title={t('about.section_1_title')} body={t('about.section_1_body')} />
          <AboutSection num="02" title={t('about.section_2_title')} body={t('about.section_2_body')} />
        </div>
      </section>

      {/* Quote / pull-quote */}
      <section className="bg-ink text-bone py-24 md:py-32">
        <div className="container-narrow text-center">
          <GoldThread className="mx-auto" />
          <blockquote className="mt-8 font-display text-d-3 leading-tight"
                      style={{ fontVariationSettings: "'opsz' 144, 'wght' 400, 'SOFT' 80" }}>
            <span className="italic">"Clothes are an investment.<br />We treat them like one."</span>
          </blockquote>
          <p className="mt-8 eyebrow text-bone/60">— The Laundry Co. team</p>
        </div>
      </section>
    </>
  );
}

function AboutSection({ num, title, body }: { num: string; title: string; body: string }) {
  return (
    <div className="col-span-12 md:col-span-6">
      <span className="font-display text-gold text-2xl"
            style={{ fontVariationSettings: "'opsz' 144, 'wght' 400" }}>
        {num}
      </span>
      <h2 className="mt-3 font-display text-3xl md:text-4xl text-ink"
          style={{ fontVariationSettings: "'opsz' 90, 'wght' 500" }}>
        {title}
      </h2>
      <p className="mt-5 font-body text-base md:text-lg text-charcoal leading-relaxed">{body}</p>
    </div>
  );
}
